import PosthogService from '~/services/posthog/PosthogService';

export interface IEodInvitePopupViewedPayload {
  professionalId: string;
}

/**
 * Fires when the EOD Invite popup is viewed
 * Event: dental_portal:invite:EOD_invite_popup_viewed
 */
export function fireEodInvitePopupViewed(payload: IEodInvitePopupViewedPayload): void {
  PosthogService.getInstance().track('dental_portal:invite:EOD_invite_popup_viewed', {
    professional_id: payload.professionalId,
  });
}
